/* FckDT custom behaviour: 3D tilt on the hero scene + AJAX add-to-cart that
   hands off to Dawn's cart drawer / notification. No dependencies. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 3D tilt: the laptop lid follows the pointer ---------- */
  function initTilt(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-fk-tilt]').forEach(function (hero) {
      if (hero.dataset.fkTiltReady || reduceMotion) return;
      hero.dataset.fkTiltReady = '1';
      var lid = hero.querySelector('.fk-lid, [data-fk-tilt-target]');
      if (!lid) return;
      var strength = parseFloat(hero.dataset.fkTilt) || 12;
      var frame = null;

      function set(x, y) {
        if (frame) cancelAnimationFrame(frame);
        frame = requestAnimationFrame(function () {
          lid.style.setProperty('--fk-rx', (x * strength).toFixed(2) + 'deg');
          lid.style.setProperty('--fk-ry', (-y * strength).toFixed(2) + 'deg');
        });
      }

      hero.addEventListener('pointermove', function (e) {
        if (e.pointerType === 'touch') return;
        var r = hero.getBoundingClientRect();
        set((e.clientX - r.left) / r.width - 0.5, (e.clientY - r.top) / r.height - 0.5);
      });
      hero.addEventListener('pointerleave', function () { set(0, 0); });

      /* phones: gentle tilt from device orientation where allowed */
      if (window.DeviceOrientationEvent && 'ontouchstart' in window) {
        window.addEventListener('deviceorientation', function (e) {
          if (e.gamma == null || e.beta == null) return;
          set(Math.max(-1, Math.min(1, e.gamma / 45)) * 0.5, Math.max(-1, Math.min(1, (e.beta - 45) / 45)) * 0.5);
        }, { passive: true });
      }
    });
  }

  /* ---------- AJAX add to cart using Dawn's cart components ---------- */
  function onAdd(e) {
    var form = e.target.closest('form[data-fk-add]');
    if (!form) return;
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (!cart || typeof cart.renderContents !== 'function' || !window.fetch) return; /* normal POST to /cart */

    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var err = form.querySelector('.fk-card__error');
    if (err) err.textContent = '';
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-disabled', 'true'); }

    var data = new FormData(form);
    data.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }).join(','));
    data.append('sections_url', window.location.pathname);
    if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);

    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
    fetch(url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: data
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          if (err) err.textContent = res.description || res.message || 'Could not add to cart.';
          return;
        }
        cart.renderContents(res);
        if (cart.classList && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        if (window.publish && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'fk-card', productVariantId: data.get('id'), cartData: res });
        }
      })
      .catch(function () { form.removeAttribute('data-fk-add'); form.submit(); })
      .finally(function () {
        if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-disabled'); }
      });
  }

  /* ---------- design pills (FCK DT / FCK ELON / Mix) pick the variant ---------- */
  function onPill(e) {
    var pill = e.target.closest('.fk-pill[data-value]');
    if (!pill) return;
    var card = pill.closest('.fk-card');
    var json = card && card.querySelector('script[data-fk-variants]');
    if (!json) return;
    var variants;
    try { variants = JSON.parse(json.textContent); } catch (err) { return; }
    var v = variants.find(function (x) { return x.o === pill.dataset.value; });
    if (!v) return;
    card.querySelectorAll('.fk-pill').forEach(function (p) { p.setAttribute('aria-pressed', p === pill ? 'true' : 'false'); });
    var id = card.querySelector('input[name="id"]');
    if (id) id.value = v.id;
    var price = card.querySelector('[data-fk-price]');
    if (price) price.innerHTML = (v.c ? '<s>' + v.c + '</s>' : '') + v.p;
    var img = card.querySelector('.fk-card__media img');
    if (img && v.i) {
      img.removeAttribute('srcset');
      img.src = v.i;
      if (v.ia) img.alt = v.ia;
    }
    var each = card.querySelector('[data-fk-each]');
    if (each && v.e) each.textContent = v.e;
    var btn = card.querySelector('.fk-card__form [type="submit"]');
    if (btn) {
      btn.disabled = !v.a;
      var label = btn.querySelector('[data-fk-label]');
      if (label) label.textContent = v.a ? (btn.dataset.addLabel || 'Add to cart') : (btn.dataset.soldLabel || 'Sold out');
    }
  }

  /* ---------- wall of shame filters ---------- */
  function onWallFilter(e) {
    var chip = e.target.closest('[data-fk-filter]');
    if (!chip) return;
    var wall = chip.closest('[data-fk-wall]');
    if (!wall) return;
    var f = chip.dataset.fkFilter;
    wall.querySelectorAll('[data-fk-filter]').forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
    var shown = 0;
    wall.querySelectorAll('.fk-wall__year').forEach(function (yr) {
      var any = false;
      yr.querySelectorAll('.fk-rc').forEach(function (rc) {
        var w = rc.dataset.who;
        var on = f === 'all' || w === f || w === 'both';
        rc.hidden = !on;
        if (on) { any = true; shown++; }
      });
      yr.hidden = !any;
    });
    var empty = wall.querySelector('.fk-wall__empty');
    if (empty) empty.hidden = shown > 0;
  }

  document.addEventListener('click', onWallFilter);
  document.addEventListener('click', onPill);
  document.addEventListener('submit', onAdd);
  document.addEventListener('DOMContentLoaded', function () { initTilt(); });
  document.addEventListener('shopify:section:load', function (e) { initTilt(e.target); });
  if (document.readyState !== 'loading') initTilt();
})();